export const PS5_DEVICES = [
  "CFI-1000A",
  "CFI-1000B",
  "CFI-1002A",
  "CFI-1002B",
  "CFI-1008A",
  "CFI-1008B",
  "CFI-1014A",
  "CFI-1014B",
  "CFI-1100A",
  "CFI-1100B",
  "CFI-1200A",
  "CFI-1200B",
  "CFI-2000A",
  "CFI-2000B",
];
